import React from 'react';
import { ApiAppParams } from '@typings/apiApp';
import ReactDOM from 'react-dom/client';

import { EmbeddedPage } from '@/modules/embedded-page';

import { config } from './config';
import desktopBg from './desktop-bg.jpg';

ReactDOM.createRoot(document.getElementById('saywhatt-page')!).render(
  <EmbeddedPage
    config={config as unknown as ApiAppParams}
    spinnerElement={document.querySelector('#saywhatt-loader')}
    desktopBg={desktopBg}
    mobileBg={desktopBg}
    promptLineBreaks={{
      desktop: 2,
    }}
  />
);
